module.exports = __webpack_public_path__ + "static/img/iotP.ea89dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iotP.jpg
// module id = 5iPk
// module chunks = 0